import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFileUpload$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFileUpload extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '5c13d94b62407c78fa95d10387f1b83d7095f89e', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'c0ca8352e09e4baee995f6138b9932bb526ecb06', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8c0bd63b5dfa28900c08fc4ff92f9d4a5316a27a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.5 3h7.91a.5.5 0 0 1 .36.15l4.08 4.07a.47.47 0 0 1 .15.35V18.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V18a.5.5 0 0 1 .5-.5h2V8h-3a.5.5 0 0 1-.5-.5v-3H6.5V8a.48.48 0 0 1-.5.48h-.5A.48.48 0 0 1 5 8V3.5a.5.5 0 0 1 .5-.5M13 15a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-5.3-2.83-2 2.15A.4.4 0 0 0 6 15h1.25v2.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5V15H10a.4.4 0 0 0 .27-.68l-2-2.15a.4.4 0 0 0-.57 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-file-upload", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-file-upload"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-file-upload":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFileUpload$1);
            }
            break;
    } });
}

const CosmosIconFileUpload = CosmosIconFileUpload$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFileUpload, defineCustomElement };
